import BaseTitle from 'components/common/BaseTitle';
import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const StepStartWrapper = styled.div`
  text-align: center;
`;

export const StepStartTitle = styled(BaseTitle)`
  margin: 40px 0;
  @media ${device.tablet} {
    margin: 40px 16px;
  }
`;

export const StepStartButtonPart = styled.div`
  > div:nth-child(1) {
    display: flex;
    justify-content: center;
    position: relative;
    > span {
      position: absolute;
      left: calc(50% + 50px);
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      line-height: 16px;
      color: rgb(71, 69, 64);
      margin-left: 15px;
      @media ${device.tablet} {
        display: none;
      }
    }
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    > p {
      margin-left: 5px;
      font-size: 14px;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;
